import { render, staticRenderFns } from "./ComponentClaim.vue?vue&type=template&id=3e950f5a&"
import script from "./ComponentClaim.vue?vue&type=script&lang=js&"
export * from "./ComponentClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports